











import { defineComponent, PropType } from '@nuxtjs/composition-api';
import TestimonialContianer from './ui/TestimonialContainer.vue';
import TestimonialImage from './ui/TestimonialImage.vue';
import TestimonialInformation from './ui/TestimonialInformation.vue';
import { IBusinessInformation, IVariant, COLOR_OPTIONS } from './index';
import BaseImage from '@/assets/images/testimonialquoteimage.png';

const variantSelected = (color: string) => {
  let colorOption = '';
  const colorOptionsObject: String[] = Object.values(COLOR_OPTIONS);

  if (colorOptionsObject.includes(color.toLowerCase())) {
    colorOption = color.toUpperCase();
  } else {
    colorOption = 'WHITE';
  }

  return colorOption;
};

const variants = {
  WHITE: {
    backgroundColor: 'bg-white',
  },
  GREY: {
    backgroundColor: 'bg-grayBackgroundWeak',
  },
  FLORALWHITE: {
    backgroundColor: 'bg-baseSecondary',
  },
} as IVariant;

export default defineComponent({
  name: 'Testimonial',
  components: {
    TestimonialContianer,
    TestimonialImage,
    TestimonialInformation,
  },

  props: {
    image: {
      type: String as PropType<string>,
    },
    text: {
      type: String as PropType<string>,
    },
    information: {
      type: Object as PropType<IBusinessInformation>,
    },
    variant: {
      type: String as PropType<string>,
      default: COLOR_OPTIONS.WHITE,
    },
    icon: {
      type: String,
      default: BaseImage,
    },
  },

  setup(props) {
    const colorOption = variantSelected(props.variant);

    return {
      colorOption,
      variants,
    };
  },
});
